import * as yup from '~/utils/yup';

export const FormAICardParam4Schema = yup
  .object({
    completeBlockId: yup.safeNumber().required('Required'),
    incompleteBlockId: yup.safeNumber().required('Required'),
    questionBlockId: yup.safeNumber().required('Required'),
    askForConfirmation: yup.boolean().default(false),
  })
  .default({})
  .transform((value) => {
    if (!value) return {};

    if (yup.string().isJson().isValidSync(value)) {
      return JSON.parse(value ?? '{}');
    }

    return value;
  });

// eslint-disable-next-line no-redeclare
export type FormAICardParam4Schema = yup.InferType<
  typeof FormAICardParam4Schema
>;
